import { translate } from "@jsverse/transloco";
import { FieldBlock, FieldBlockType } from "app/main/pages/general-editor-tabs/content-tab/content-tab.dto";

export enum SelectedFieldEnum {
    TextField = '1',
    CheckboxField = '2',
    DroplistField = '3',
    DatepickerField = '4',
    SignatureField = '5',
    ListField = '6'
}

export enum SelectedFieldBlock {
    ContentField = 1,
    PdfField = 0
}

export enum FieldTypeEnum {
  Text = 'text',
  Checkbox = 'checkbox',
  Droplist = 'droplist',
  Datepicker = 'datepicker',
  Signature = 'signature',
  List = 'list'
}

export enum FieldEnum {
  TextField = 'text-field',
  CheckboxField = 'checkbox-field',
  DroplistField = 'droplist-field',
  DatepickerField = 'datepicker-field',
  SignatureField = 'signature-field',
  ListField = 'multichoice-field'
}

export function fieldBlocks(): FieldBlock[] {
    return [ 
        {
          field_block: 'text-field',
          type: 'text',
          name: translate("Content text field (Template/Document - section) - Text Field"),
          block: FieldBlockType.ContentFields 
        },
        {
          field_block: 'checkbox-field',
          type: 'checkbox',
          name: translate("Content check Box field (Template/Document - section) - Check Box"),
          block: FieldBlockType.ContentFields 
        },
        {
          field_block: 'droplist-field',
          type: 'droplist',
          name: translate("Content drop list (Template/Document - section) - Drop List"),
          block: FieldBlockType.ContentFields 
        },
        {
          field_block: 'multichoice-field',
          type: 'multichoice',
          name: translate("Content list field (Template/Document - section) - List"),
          block: FieldBlockType.ContentFields 
        },
        {
          field_block: 'datepicker-field',
          type: 'datepicker',
          name: translate("Content date picker field (Template/Document - section) - Date Picker"),
          block: FieldBlockType.ContentFields 
        },
        {
          field_block: 'signature-field',
          type: 'signature',
          name: translate("Content signing box field (Template/Document - section) - Signing Box"),
          block: FieldBlockType.ContentFields 
        },
      ]
}